import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { IGroupRule, IGroupRuleChangeEvent } from './group-rule.model'
// import { IRule } from './rule.model'
// import { ConditionsEnum, ISVariableValueEnum, OperatorsEnum } from './definitions.enum'
import { QueryBuilderService } from './query-builder.service'

@Component({
    selector: 'app-configuration-query-builder',
    templateUrl: './configuration-query-builder.component.html',
    standalone: false
})
export class ConfigurationQueryBuilderComponent implements OnInit {
  @Input() groupRuleInput: IGroupRule
  @Input() stringAsGroupRuleInput: string
  @Output() queryChangeEvent: EventEmitter<string | null> = new EventEmitter<string | null>()

  private _queryString: string = null

  public get queryString(): string {
    return this._queryString
  }

  public constructor(private service: QueryBuilderService) {}

  public onValueChanged($event: IGroupRuleChangeEvent): void {
    this._queryString = this.service.groupToString($event.group)
    this.queryChangeEvent.next(this._queryString)
  }

  /* private groupToString(group: IGroupRule): string | null {
    if (group.rules.length === 0) {
      return null
    }
    const conditions: string[] = []
    try {
      for (let i = 0; i < group.rules.length; i++) {
        const isRule = group.rules[i]['rules'] === undefined
        if (isRule) {
          const rule = group.rules[i] as IRule
          if (rule.field === null || rule.operator === null || rule.value === null) {
            throw Error('Empty rule.')
          }
          conditions.push(this.ruleToString(rule))
          // conditions.push(`${rule.field} ${rule.operator} ${rule.value}`)
        } else {
          const groupCondition = this.groupToString(group.rules[i] as IGroupRule)
          if (groupCondition === null) {
            throw Error('Empty group rule.')
          }
          conditions.push(`(${groupCondition})`)
        }
      }
      return conditions.join(` ${group.condition} `)
    } catch (e) {
      return null
    }
  }

  private ruleToString(rule: IRule): string {
    if (rule.operator.trim() === OperatorsEnum.Is_NOT) {
      return `!${rule.field}`
    } else {
      return `${rule.field}`
    }
  }

  private stringToArray(str): any[] {
    let i = 0
    function main() {
      const arr = []
      let startIndex = i

      function addWord() {
        if (i - 1 > startIndex) {
          arr.push(str.slice(startIndex, i - 1))
        }
      }

      while (i <= str.length) {
        // Before was i < str.length ~ check in the future
        switch (str[i++]) {
          case ' ':
            addWord()
            startIndex = i
            continue
          case '(':
            arr.push(main())
            startIndex = i
            continue
          case ')':
            addWord()
            return arr
        }
      }
      addWord()
      return arr
    }
    return main()
  }

  private arrayToGroupRule(arr: any[]): IGroupRule {
    function stringAsRule(ruleAsString: string): IRule | null {
      const variableType: 'FE' | 'IS' = 'IS'
      switch (true) {
        case variableType === 'IS':
          if (ruleAsString.indexOf('!') === 0) {
            return {
              field: ruleAsString.substring(1, ruleAsString.length),
              operator: OperatorsEnum.Is_NOT,
              value: ISVariableValueEnum.Active,
            }
          } else {
            return {
              field: ruleAsString,
              operator: OperatorsEnum.Is,
              value: ISVariableValueEnum.Active,
            }
          }
        default:
          return null
      }
    }

    let tmp = []
    let condition: ConditionsEnum.AND | ConditionsEnum.OR = ConditionsEnum.AND
    const rules: (IRule | IGroupRule)[] = []

    for (let i = 0; i < arr.length; i++) {
      if (arr[i] instanceof Array) {
        rules.push(this.arrayToGroupRule(arr[i]))
      } else {
        if (
          arr[i].toUpperCase() !== ConditionsEnum.AND &&
          arr[i].toUpperCase() !== ConditionsEnum.OR
        ) {
          tmp.push(arr[i])
        }
        if (
          arr[i].toUpperCase() === ConditionsEnum.AND ||
          arr[i].toUpperCase() === ConditionsEnum.OR ||
          i === arr.length - 1
        ) {
          if (
            arr[i].toUpperCase() === ConditionsEnum.AND ||
            arr[i].toUpperCase() === ConditionsEnum.OR
          ) {
            condition = arr[i]
          }
          if (tmp.length > 0) {
            const rule = stringAsRule(tmp.join(' '))
            if (rule !== null) {
              rules.push(rule)
            }
          }
          tmp = []
        }
      }
    }
    return {
      condition: condition,
      rules: rules,
    }
  } */

  ngOnInit(): void {
    if (this.stringAsGroupRuleInput) {
      const stringToArray = this.service.stringToArray(this.stringAsGroupRuleInput)
      this.groupRuleInput = this.service.arrayToGroupRule(stringToArray)
    }
  }
}
